var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class WorkShiftService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "workshift";
    }
    updateWorkShifts(workShifts) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.put(`${this.controllerName}/`, workShifts);
            return data;
        });
    }
    approveWorkShifts(workShiftIds) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`${this.controllerName}/approve`, workShiftIds);
            return data;
        });
    }
    customCreate(workshift) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`${this.controllerName}`, workshift);
            return data;
        });
    }
}
export const workShiftService = new WorkShiftService();
//# sourceMappingURL=workShiftService.js.map